module.exports = __webpack_public_path__ + "8e7da66bd895cb73c23f4f720d84b7e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/adobe_2022_chart.png
// module id = 1622
// module chunks = 0